// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".convert-key-confirm .info-text{word-break:break-word}.convert-key-confirm .confirm-content__gift{margin:20px auto 0;overflow:auto}.convert-key-confirm .gift-area{margin:0 auto;overflow:auto;width:80%}.convert-key-confirm.is-mobile .el-dialog{width:90%!important}.convert-key-confirm .el-icon-warning{color:#e5ab36}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"siteFontFamily": "system-ui,sans-serif,math,ui-rounded,ui-monospce"
};
module.exports = ___CSS_LOADER_EXPORT___;
